module.exports = __webpack_public_path__ + "img/containertitle.174f2717.png";